module.exports = __webpack_public_path__ + "static/media/icon_stop_alt.a8243e7a.png";